import React from 'react';
import FirtChallangeLeaderBoardTableComponent from "./FirtChallangeLeaderBoardTableComponent"

function LeaderboardModal({ show, onClose }) {
  if (!show) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center p-4 z-50"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.85)" }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="rounded-3xl border backdrop-blur-xl max-w-[80%] w-full  overflow-hidden relative"
        style={{
          backgroundColor: "rgba(17, 24, 39, 0.95)",
          borderColor: "rgba(253, 13, 14, 0.3)",
          boxShadow: "0 8px 32px rgba(253, 13, 14, 0.3)",
        }}
      >
        <div
          className="flex items-center justify-between p-6 border-b"
          style={{ borderColor: "rgba(55, 65, 81, 0.5)" }}
        >
          <h2 className="text-2xl font-bold text-white flex items-center gap-3">
            <div
              className="w-10 h-10 rounded-xl flex items-center justify-center"
              style={{
                backgroundColor: "#fd0d0e",
                boxShadow: "0 4px 15px rgba(253, 13, 14, 0.3)",
              }}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                />
              </svg>
            </div>
           امتیازات رده بندی فردی 
          </h2>
          <button
            onClick={onClose}
            className="w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-200 hover:scale-110"
            style={{
              backgroundColor: "rgba(220, 38, 38, 0.2)",
              border: "1px solid rgba(220, 38, 38, 0.3)",
            }}
          >
            <svg
              className="w-6 h-6 text-red-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div
          className="overflow-y-auto p-[5vh]"
          style={{ maxHeight: "calc(90vh - 100px)" }}
        >
          <FirtChallangeLeaderBoardTableComponent />
        </div>
      </div>
    </div>
  );
}

export default LeaderboardModal;